<template>
  <div
    class="bg-white rounded-lg card flex flex-col justify-between items-start shadow-md gap-4 flex-1 border-color-blue p-3"
  >
    <span
      class="text-sm lg:text-lg font-bold text-gray-700 tracking-tight whitespace-nowrap"
    >
      {{ title }}
    </span>
    <span class="text-sm lg:text-lg font-semibold text-gray-700 tracking-tight">
      {{ formattedValue }}
    </span>
    <span v-if="optionValue" class="text-option-value text-sm">
      {{ optionValue || '\u00A0' }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'GeneralCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    optionValue: {
      type: [String, Number],
      required: false,
      default: '',
    },
    isCurrency: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    formattedValue() {
      if (typeof this.value === 'number' && this.isCurrency) {
        return this.value.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });
      }
      return this.value;
    },
  },
};
</script>

<style scoped>
.card {
  min-height: 124px;
}
.text-gray-700 {
  color: #434343;
}
.text-lg {
  font-size: 1rem;
  line-height: 1.5rem;
  letter-spacing: 0.15px;
}
.border-color-blue {
  border-left: 4px solid #114880;
}
.text-option-value {
  color: #12cc68;
  font-weight: 700;
}
</style>
